"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/infoSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type InfoSectionConInfosItem = {
    key: Key | null | undefined;
    /** Detected variants: "Customer Support" | "Drop Us an Email" */
    p0Text: ReactNode;
    /** Detected variants: "+1 56589 54598" | "info1256@example.com" */
    p1Text: ReactNode;
    /** Detected variants: "isax isax-headphone5" | "isax isax-message-25" */
    className: string;
    /** Detected variants: "con-info" */
    divClassName?: string;
    /** Detected variants: "con-details" */
    div0ClassName?: string;
    /** Detected variants: "title" */
    p0ClassName?: string;
    /** Detected variants: "description" */
    p1ClassName?: string;
    /** Detected variants: "con-icon" */
    span0ClassName?: string;
};
export type HomeOneInfoSectionGeneratedProps = {
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Working for Your Better Health." */
    sectionDiv0Div0Div0Div0H30H3Text?: ReactNode;
    sectionDiv0Div0Div0Div0H30H3Visible?: boolean;
    sectionDiv0Div0Div0Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div1DivDataWowDuration?: string;
    /** Default: "element" */
    sectionDiv0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/info-bg.png" */
    sectionDiv0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    infoSectionConInfos: InfoSectionConInfosItem[];
    infoSectionConInfosItemWrapper?: (item: InfoSectionConInfosItem, content: ReactNode) => ReactNode;
    infoSectionConInfosRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeOneInfoSectionGenerated: FC<HomeOneInfoSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H30H3Text = "Working for Your Better Health.",
    sectionDiv0Div0Div0Div0H30H3Visible,
    sectionDiv0Div0Div0Div0H30H3Renderer,
    sectionDiv0Div0Div0Div0H30H3Props,
    sectionDiv0Div0Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div0ImageWithBasePath0ImageAlt = "element",
    sectionDiv0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/info-bg.png",
    sectionDiv0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0ImageWithBasePath0ImageProps,
    infoSectionConInfos,
    infoSectionConInfosItemWrapper,
    infoSectionConInfosRenderer,
}) => {
    return (
        <section className="info-section">
            <div className="container">
                <div className="contact-info">
                    <div className="info-col">
                        <div className="wow fadeOutUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div0Div0H30H3Visible, sectionDiv0Div0Div0Div0H30H3Renderer, (
                                <h3 className="info-title" {...(sectionDiv0Div0Div0Div0H30H3Props ?? {})}>{sectionDiv0Div0Div0Div0H30H3Text}</h3>
                            ))}
                        </div>
                        <div className="support-info wow fadeOutDown" data-wow-duration={sectionDiv0Div0Div0Div1DivDataWowDuration}>
                            {renderCollectionNode(
                                infoSectionConInfos,
                                (item: InfoSectionConInfosItem) => (
                                    <div className={item.divClassName ?? "con-info"} key={item.key}>
                                        <span className={item.span0ClassName ?? "con-icon"}>
                                            <i className={item.className} />
                                        </span>
                                        <div className={item.div0ClassName ?? "con-details"}>
                                            <p className={item.p0ClassName ?? "title"}>{item.p0Text}</p>
                                            <p className={item.p1ClassName ?? "description"}>{item.p1Text}</p>
                                        </div>
                                    </div>
                                ),
                                infoSectionConInfosItemWrapper,
                                infoSectionConInfosRenderer
                            )}
                        </div>
                    </div>
                    {renderNode(sectionDiv0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0ImageWithBasePath0ImageAlt} className="img-fluid element-01" {...(sectionDiv0Div0ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeOneInfoSectionGenerated;
